import React from 'react';
import { SelectInputValue } from './SelectInputValue';
import { ISelectOption, onRemoveValueType } from '../common/types';
import { makeStyles } from '@material-ui/core';

type PSelectInputValues = {
  selected: Array<ISelectOption>;
  onRemove: onRemoveValueType;
};

const useStyles = makeStyles(() => ({
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-10px 0 0 -10px',
  },
  list__item: {
    margin: '10px 0 0 10px',
  },
}));

export const SelectInputValues: React.FC<PSelectInputValues> = (props) => {
  const { selected, onRemove } = props;
  const classes = useStyles();

  return (
    <div className={classes.list}>
      {selected.map((el) => (
        <SelectInputValue
          key={el.value}
          option={el}
          className={classes.list__item}
          onRemove={(e, elem) => onRemove(e, elem)}
        />
      ))}
    </div>
  );
};
